"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_FEATURE_ORDER = exports.APP_FEATURE_DESCRIPTIONS = exports.APP_FEATURE_LABELS = exports.APP_FEATURE_DEFAULTS = exports.APP_FEATURE_FLAG_KEYS = exports.AppFeature = void 0;
exports.appFeatureForFlagKey = appFeatureForFlagKey;
const enums_1 = require("../enums");
/**
 * Features under test that admins can switch off instantly (Feature Flags page). On = live for
 * everyone; off = the app hides it and the backend stops serving its requests, crons and pushes.
 */
var AppFeature;
(function (AppFeature) {
  /** New app UI (MapScreen, new nav bar, new venue sheet). Off = the old UI. */
  AppFeature["MapUi"] = "mapUi";
  /** Square tickets: in-app purchases, Square tickets in My Tickets and refund requests. */
  AppFeature["Payments"] = "payments";
  AppFeature["Stickers"] = "stickers";
  /** Admin import from Eventbrite links. */
  AppFeature["Eventbrite"] = "eventbrite";
  /** Eventbrite tickets: connecting an Eventbrite account in the app and showing its tickets. */
  AppFeature["EventbriteTickets"] = "eventbriteTickets";
  /** Weekly auto check-ins (generated plans, geofence check-ins, reminders). */
  AppFeature["AutoCheckIns"] = "autoCheckIns";
  /** User-density hotspots and partnered hotspots (ticker + highlight modal). */
  AppFeature["Hotspots"] = "hotspots";
  /** Sign in / sign up / account linking with Google. Admin panel Google login is not affected. */
  AppFeature["GoogleAuth"] = "googleAuth";
  /**
   * Google Cloud Vision check of profile photos (onboarding, profile, launch reminder). Off = photos
   * are saved without a check and stay unverified.
   */
  AppFeature["PhotoVerification"] = "photoVerification";
  /** The new map's "Check In" button next to the recenter button. */
  AppFeature["CheckInButton"] = "checkInButton";
  /** Settings > Connected accounts (link Google / Apple / Eventbrite). Off: the row is hidden in the app. */
  AppFeature["ConnectedAccounts"] = "connectedAccounts";
  /** The "Sync to Google Calendar" switch on My Plans. Off: the switch is hidden in the app. */
  AppFeature["CalendarSync"] = "calendarSync";
  /** Settings > My Tickets (also needs Square Tickets or Eventbrite Tickets on). Off: the row is hidden in the app. */
  AppFeature["MyTickets"] = "myTickets";
  /** Settings > Notifications: "Vibrate on notifications" and the vibration pattern. Off: the section is hidden in the app. */
  AppFeature["Vibrations"] = "vibrations";
  /** The My Plans tab in the new app's bottom bar. Off: the tab is hidden. */
  AppFeature["MyPlansTab"] = "myPlansTab";
  /** Map's My Places List / Footprint List buttons in their filter colors. Off: secondary black. */
  AppFeature["ColoredListButtons"] = "coloredListButtons";
})(AppFeature || (exports.AppFeature = AppFeature = {}));
exports.APP_FEATURE_FLAG_KEYS = {
  [AppFeature.MapUi]: enums_1.FeatureFlagKey.MapUiEnabled,
  [AppFeature.Payments]: enums_1.FeatureFlagKey.PaymentsEnabled,
  [AppFeature.Stickers]: enums_1.FeatureFlagKey.StickersEnabled,
  [AppFeature.Eventbrite]: enums_1.FeatureFlagKey.EventbriteEnabled,
  [AppFeature.EventbriteTickets]: enums_1.FeatureFlagKey.EventbriteTicketsEnabled,
  [AppFeature.AutoCheckIns]: enums_1.FeatureFlagKey.AutoCheckInsEnabled,
  [AppFeature.Hotspots]: enums_1.FeatureFlagKey.HotspotsEnabled,
  [AppFeature.GoogleAuth]: enums_1.FeatureFlagKey.GoogleAuthEnabled,
  [AppFeature.PhotoVerification]: enums_1.FeatureFlagKey.PhotoVerificationEnabled,
  [AppFeature.CheckInButton]: enums_1.FeatureFlagKey.CheckInButtonEnabled,
  [AppFeature.ConnectedAccounts]: enums_1.FeatureFlagKey.ConnectedAccountsEnabled,
  [AppFeature.CalendarSync]: enums_1.FeatureFlagKey.CalendarSyncEnabled,
  [AppFeature.MyTickets]: enums_1.FeatureFlagKey.MyTicketsEnabled,
  [AppFeature.Vibrations]: enums_1.FeatureFlagKey.VibrationsEnabled,
  [AppFeature.MyPlansTab]: enums_1.FeatureFlagKey.MyPlansTabEnabled,
  [AppFeature.ColoredListButtons]: enums_1.FeatureFlagKey.ColoredListButtonsEnabled
};
/** Used when a flag row is missing or not a boolean. Matches the seeded values. */
exports.APP_FEATURE_DEFAULTS = {
  [AppFeature.MapUi]: false,
  [AppFeature.Payments]: false,
  [AppFeature.Stickers]: true,
  [AppFeature.Eventbrite]: true,
  [AppFeature.EventbriteTickets]: false,
  [AppFeature.AutoCheckIns]: true,
  [AppFeature.Hotspots]: true,
  [AppFeature.GoogleAuth]: true,
  [AppFeature.PhotoVerification]: true,
  [AppFeature.CheckInButton]: true,
  [AppFeature.ConnectedAccounts]: false,
  [AppFeature.CalendarSync]: false,
  [AppFeature.MyTickets]: false,
  [AppFeature.Vibrations]: false,
  [AppFeature.MyPlansTab]: false,
  [AppFeature.ColoredListButtons]: false
};
exports.APP_FEATURE_LABELS = {
  [AppFeature.MapUi]: 'Map UI',
  [AppFeature.Payments]: 'Square Tickets',
  [AppFeature.Stickers]: 'Stickers',
  [AppFeature.Eventbrite]: 'Eventbrite Import',
  [AppFeature.EventbriteTickets]: 'Eventbrite Tickets',
  [AppFeature.AutoCheckIns]: 'Auto Check-ins',
  [AppFeature.Hotspots]: 'Hotspots',
  [AppFeature.GoogleAuth]: 'Google Sign-In',
  [AppFeature.PhotoVerification]: 'Photo Verification',
  [AppFeature.CheckInButton]: 'Map Check In Button',
  [AppFeature.ConnectedAccounts]: 'Connected Accounts',
  [AppFeature.CalendarSync]: 'Google Calendar Sync',
  [AppFeature.MyTickets]: 'My Tickets',
  [AppFeature.Vibrations]: 'Vibration Settings',
  [AppFeature.MyPlansTab]: 'My Plans Tab',
  [AppFeature.ColoredListButtons]: 'Colored List Buttons'
};
exports.APP_FEATURE_DESCRIPTIONS = {
  [AppFeature.MapUi]: 'New app UI (map screen, navigation bar, venue sheet) for all users. Off: the old UI.',
  [AppFeature.Payments]: 'Buying tickets in the app with Square, Square tickets in My Tickets and refund requests. Off: ticketed events fall back to RSVP and the API refuses purchases. Square webhooks and admin refunds keep working.',
  [AppFeature.Stickers]: 'Posting and viewing venue stickers, sticker counts on the map and in Spotlight.',
  [AppFeature.Eventbrite]: 'Admin "Import from Eventbrite" on the event form.',
  [AppFeature.EventbriteTickets]: 'Users connect their Eventbrite account in Settings > Connected accounts and see their Eventbrite tickets in My Tickets and on ticketed events. Off: the Eventbrite row is hidden and the API refuses it.',
  [AppFeature.AutoCheckIns]: 'Weekly auto check-ins. Off: no new plans are generated, no geofence check-ins and no reminder pushes.',
  [AppFeature.Hotspots]: 'User-density hotspots (map, Spotlight "near hotspot") and the partnered hotspot ticker / modal.',
  [AppFeature.GoogleAuth]: 'Sign in, sign up and account linking with Google in the app. Off: the Google buttons are hidden and the API refuses Google sign-in. Admin panel Google login keeps working.',
  [AppFeature.PhotoVerification]: 'Profile photo check (Google Cloud Vision) in onboarding and profile, plus the unverified photo reminder. Off: photos are saved without a check and stay unverified.',
  [AppFeature.CheckInButton]: 'The "Check In" button at the top of the new map, next to the recenter button. Off: the button is hidden; users can still check in from a venue.',
  [AppFeature.ConnectedAccounts]: 'Settings > Connected accounts (link Google / Apple, plus Eventbrite while Eventbrite Tickets is on). Off: the row is hidden in the app.',
  [AppFeature.CalendarSync]: 'The "Sync to Google Calendar" switch on My Plans. Off: the switch is hidden in the app.',
  [AppFeature.MyTickets]: 'Settings > My Tickets (also needs Square Tickets or Eventbrite Tickets on). Off: the row is hidden in the app.',
  [AppFeature.Vibrations]: 'Settings > Notifications: "Vibrate on notifications" and the vibration pattern. Off: the section is hidden in the app.',
  [AppFeature.MyPlansTab]: 'The My Plans tab in the new app\'s bottom bar. Off: the tab is hidden.',
  [AppFeature.ColoredListButtons]: 'Map "My Places List" and "Footprint List" buttons in their filter colors (cherry / teal). Off: black buttons.'
};
exports.APP_FEATURE_ORDER = [AppFeature.MapUi, AppFeature.Payments, AppFeature.Stickers, AppFeature.Eventbrite, AppFeature.EventbriteTickets, AppFeature.AutoCheckIns, AppFeature.Hotspots, AppFeature.GoogleAuth, AppFeature.PhotoVerification, AppFeature.CheckInButton, AppFeature.ConnectedAccounts, AppFeature.CalendarSync, AppFeature.MyTickets, AppFeature.Vibrations, AppFeature.MyPlansTab, AppFeature.ColoredListButtons];
function appFeatureForFlagKey(key) {
  var _exports$APP_FEATURE_;
  return (_exports$APP_FEATURE_ = exports.APP_FEATURE_ORDER.find(feature => exports.APP_FEATURE_FLAG_KEYS[feature] === key)) !== null && _exports$APP_FEATURE_ !== void 0 ? _exports$APP_FEATURE_ : null;
}
//# sourceMappingURL=app-features.js.map